import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';

// api_maker wraps every successful response as { success, statusCode, data }.
// Unwrap it here so services receive the payload directly.
export const responseInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse) {
        const body = event.body as { success?: boolean; data?: unknown } | null;
        if (body?.success === true) {
          return event.clone({ body: body.data ?? null });
        }
      }
      return event;
    }),
  );
};
